import {Text} from '@treatwell/ui';
import styles from './SectionTitle.module.css';

interface Props {
  title: string;
  type?: 'body' | 'xlHeader';
}

export const SectionTitle = ({title, type = 'body'}: Props) => {
  return (
    <Text as="h2" type={type} className={styles.title} data-cy="SectionTitle">
      {title}
    </Text>
  );
};
